export default "__VITE_ASSET__a9hqegOB__"